import Cookies from 'universal-cookie'

import {
	Nullable,
	AuthRequest,
	AuthSuccessResponse,
} from '../../types'

export interface AuthState {
	token: Nullable<string>
	fetching: boolean
	email: Nullable<string>
	error: any
}

export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAILURE = 'AUTH_FAILURE'
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN'
export const AUTH_LOGOUT_REQUEST = 'AUTH_LOGOUT_REQUEST'
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS'
export const AUTH_LOGOUT_FAILURE = 'AUTH_LOGOUT_FAILURE'

export const authRequestAction = (params: any) => ({ type: AUTH_REQUEST, params })
export const authSuccessAction = () => ({ type: AUTH_SUCCESS })
export const authFailureAction = (payload: any) => ({ type: AUTH_FAILURE, payload })
export const authSetTokenAction = (payload: AuthSuccessResponse) => ({
	type: AUTH_SET_TOKEN,
	payload,
})
export const authLogoutRequestAction = () => ({ type: AUTH_LOGOUT_REQUEST })
export const authLogoutSuccessAction = () => ({ type: AUTH_LOGOUT_SUCCESS })
export const authLogoutFailureAction = () => ({ type: AUTH_LOGOUT_FAILURE })

const initialState: AuthState = {
	token: null,
	fetching: false,
	email: null,
	error: null,
}

const AuthReducer = (state = initialState, action: any): AuthState => {
	const { type, payload, params } = action
	const cookies = new Cookies()
	switch (type) {
		case AUTH_SET_TOKEN: {
			const { token } = payload as AuthSuccessResponse
			cookies.set('token', token, {
				// maxAge: 60 * 60 * 1000,
				// httpOnly: true,
				// secure: true,
				sameSite: 'strict',
				path: '/'
			})
			return {
				...state,
				fetching: true,
				token,
			}
		}
		case AUTH_REQUEST: {
			const { email } = params as AuthRequest
			return { ...state, error: null, fetching: true, email }
		}
		case AUTH_SUCCESS: {
			return { ...state, fetching: false }
		}
		case AUTH_FAILURE: {
			const { error } = payload
			return { ...state, fetching: false, error }
		}
		// case AUTH_LOGOUT_REQUEST: {
		// 	return { ...state }
		// }
		case AUTH_LOGOUT_SUCCESS: {
			cookies.remove('token')
			return { ...initialState }
		}
		// case AUTH_LOGOUT_FAILURE: {
		// 	return { ...state }
		// }
		default:
			return state
	}
}

export default AuthReducer
